import request from "src/api/request-manager/gateway";
import { CompanyInfoResponse } from "./types/company.types";

const prefixURL = "/dashboard/v1";

const CompanyAPI = {
  getCompanyInfo(): Promise<CompanyInfoResponse> {
    return request.get<CompanyInfoResponse>(`${prefixURL}/companies/info`);
  }
};

export default CompanyAPI;
